<template>
    <v-container fluid>

        <!-- LOOKS GOOD TABLE PREVIEW -->
        <v-row>
            <v-col cols="12" v-if="errorLines.length===0">

                <v-alert type="success" class="body-2">
                    Great CSV file looks good! Here is first 100 rows for inspection.
                </v-alert>

                <v-data-table
                        :headers="tableHeaders"
                        :items="data"
                        item-key="row"
                        class="elevation-4"
                        :footer-props="{itemsPerPageOptions:[10,25,50,100]}"
                        :loading="loading"
                >
                    <!-- ROWS -->
                    <template v-slot:body="{ items }">
                        <tbody>
                        <tr v-for="(item, index) in items" :key="item.name">
                            <td class="text-left">{{ index+1 }}</td>
                            <td class="text-left text-no-wrap" v-for="name in item">
                                {{ name }}
                            </td>
                        </tr>
                        </tbody>
                    </template>

                </v-data-table>
            </v-col>
        </v-row>

        <v-row>

            <v-col cols="12" v-if="errorLines.length===0">

                <v-btn color="primary"
                       @click="continueClicked">
                    Next let's map your data
                </v-btn>

                <v-btn color="secondary"
                       @click="cancelClicked">
                    Restart
                </v-btn>

            </v-col>

        </v-row>

        <!-- STRUCTURAL ERRORS TABLE -->
        <v-row>

            <!-- ERROR TABLE -->
            <v-col cols="12" v-if="errorLines.length>0">

                <v-alert type="error" class="body-2">
                    Errors were found in the following lines. (Click arrow down details)
                </v-alert>

                <v-data-table
                        show-expand
                        :expanded.sync="expanded"
                        :headers="errorTableHeaders"
                        :items="errorLines"
                        item-key="lineNumber"
                        class="elevation-1"
                        :footer-props="{itemsPerPageOptions:[10,25,50,100]}"
                >

                    <!-- EXPAND -->
                    <template v-slot:expanded-item="{ headers, item }">
                        <td :colspan="headers.length" class="pa-0 white">
                            <v-sheet fluid tile color="white" flat class="text-left pa-2">
                                <div class="csv red--text text--darken-4 text-no-wrap">
                                    {{item.line}}
                                </div>
                            </v-sheet>
                        </td>
                    </template>
                </v-data-table>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12" v-if="errorLines.length>0">
                <v-btn color="primary"
                       @click="cancelClicked">
                    Try again
                </v-btn>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>

    export default {
        props: {
            headers: {
                type: Array,
                required: true,
            },
            data: {
                type: Array,
                required: true,
            },
            errorLines: {
                type: Array,
                required: true,
            },
            loading: {
                type: Boolean,
                required: true
            }
        },

        data() {
            return {

                // Error table
                errorTableHeaders: [
                    {text: 'Line', value: 'lineNumber', align: 'left'},
                    {text: 'Type', value: 'type', align: 'left'},
                    {text: 'Error', value: 'message', align: 'left', sortable: false},
                ],

                expand: false,
                expanded: null,
            }
        },

        computed: {
            tableHeaders() {
                let tableHeaders = [];

                tableHeaders.push({text: 'LINE', value: 'row', align: 'left', sortable: true});

                this.headers.forEach(header => {

                    let parts = header.split(":");

                    if (parts.length === 2) {
                        header = parts[0].trim() + ":" + parts[1].trim();
                    }

                    tableHeaders.push({
                        text: header.toUpperCase(),
                        value: header,
                        align: 'left'
                    });
                });

                return tableHeaders;
            }
        },

        methods: {
            continueClicked() {
                this.$emit('complete');
            },
            cancelClicked() {
                this.$emit('reset');
            }
        }
    }

</script>

<style>
    .csv {
        font-weight: bold;
        font-size: 1.2em;
    }
</style>
